export enum EActions {
  getCurrenciesRequest = "getCurrenciesRequest",
  getCurrenciesSuccess = "getCurrenciesSuccess",
  getCurrenciesFail = "getCurrenciesFail",
}
